import { auth } from './firebase';
import { EMAIL_PREFIX } from '../constants/common';

// Sign In
export const doSignInWithEmailAndPassword = (username, password) =>{
  let email = username + EMAIL_PREFIX;
  return auth.signInWithEmailAndPassword(email, password);
}

// Sign out
export const doSignOut = () =>{
  return auth.signOut(); 
}

export const getCurrentUserToken = () =>
  auth.currentUser.getIdTokenResult();



// WEBPACK FOOTER //
// ./src/firebase/auth.js